export default { props: { type: { type: 'enum', values: ['underline'] } } };
